import { jsx as t, jsxs as B } from "react/jsx-runtime";
import { createContext as b, useContext as m, useMemo as f } from "react";
import { faInfoCircle as h, faExclamationCircle as C, faExclamationTriangle as I, faTimes as N } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon as u } from "@fortawesome/react-fontawesome";
import { Portal as y } from "@radix-ui/react-portal";
import { BoxIcon as j } from "../box-icon/BoxIcon.js";
import { Button as P } from "../button/Button.js";
import { BannerProviderContext as R } from "./BannerProvider.js";
import { twMerge as i } from "tailwind-merge";
const l = b({ type: "info" }), G = ({
  dismissable: o,
  type: r = "info",
  onDismiss: e,
  children: n,
  className: a,
  ...s
}) => {
  const { containerRef: c, inView: v } = m(R), w = f(() => ({ type: r, onDismiss: e }), [r, e]);
  return v ? /* @__PURE__ */ t(y, { container: c.current, children: /* @__PURE__ */ t(l.Provider, { value: w, children: /* @__PURE__ */ B(x, { ...s, children: [
    r !== "none" && /* @__PURE__ */ t(p, {}),
    /* @__PURE__ */ t(d, { className: a, children: n }),
    o && /* @__PURE__ */ t(g, {})
  ] }) }) }) : null;
}, x = ({ className: o, children: r, ...e }) => /* @__PURE__ */ t(
  "div",
  {
    className: i(
      "relative flex flex-col items-center gap-3 border-b border-gray-300 bg-white px-4 py-3 sm:flex-row sm:px-8",
      o
    ),
    ...e,
    children: r
  }
), p = ({ children: o, className: r, ...e }) => {
  const { type: n } = m(l), [a, s] = f(() => {
    switch (n) {
      case "warning":
        return [I, "!text-warning-600"];
      case "error":
        return [C, "!text-error-600"];
      case "info":
      default:
        return [h, "!text-brand-violet-dark"];
    }
  }, [n]);
  return /* @__PURE__ */ t(j, { size: "sm", className: i("hidden sm:flex", r), ...e, children: o ?? /* @__PURE__ */ t(u, { icon: a, className: s }) });
}, d = ({ className: o, children: r, ...e }) => /* @__PURE__ */ t(
  "div",
  {
    className: i(
      "relative flex w-full flex-col justify-between gap-2 pr-8 sm:flex-row sm:items-center sm:gap-6 sm:pr-0",
      o
    ),
    ...e,
    children: r
  }
), g = ({
  variant: o = "transparent",
  className: r,
  onClick: e,
  children: n,
  ...a
}) => {
  const { onDismiss: s } = m(l);
  return /* @__PURE__ */ t(
    P,
    {
      variant: o,
      shape: n ? void 0 : "square",
      size: "xs",
      color: "neutral",
      className: i(
        "absolute right-0 top-0 hover:bg-gray-100 sm:!static sm:ml-auto",
        r
      ),
      "aria-label": n ? void 0 : "Dismiss",
      onClick: (c) => {
        s == null || s(), e == null || e(c);
      },
      ...a,
      children: n ?? /* @__PURE__ */ t(u, { icon: N })
    }
  );
}, H = x, J = p, K = d, L = g;
export {
  G as Banner,
  d as BannerContent,
  g as BannerDismissButton,
  p as BannerIcon,
  x as BannerRoot,
  K as Content,
  L as DismissButton,
  J as Icon,
  H as Root
};
